export const getQuoteListCardData = () => {
  let saveData = void 0;
  try {
    saveData = sessionStorage.getItem('jove-quote-list-card-data');
    if (saveData) saveData = JSON.parse(saveData);
  } catch (e) {}

  return saveData;
};

export const saveQuoteListCardData = (data: { countTagList?: [] }) => {
  const saveData = getQuoteListCardData();
  sessionStorage.setItem(
    'jove-quote-list-card-data',
    JSON.stringify({ ...saveData, ...data })
  );
};
